<div class="col col-12 col-lg-12 px-0">
  <div class="breadcrumbs">
    <div class="mb-3">
      <span>
        <span><a href="javascript:void(0)" [innerHTML]="AdminRootText" [routerLink]="AdminRootLink" [queryParams]="AdminRootLinkQueryParam"></a></span>
        <span> &gt; </span>
        <ng-container *ngFor="let item of Breadcrumbs">
          <ng-container *ngIf="item.IsLink">
            <span>
              <a href="javascript:void(0)" [innerHTML]="item.DisplayText" [routerLink]="item.Url" [queryParams]="item.queryParams"></a>
            </span>
            <span> &gt; </span>
          </ng-container>
          <span *ngIf="!item.IsLink" [innerHTML]="item.DisplayText"></span>
        </ng-container>
      </span>
    </div>
  </div>
</div>
